import { useState, useEffect } from "react";
import axios from "axios";
import PlayerFE from "../video/PlayerFE";
import constants from "../../constants";
import { useRecordContentWatchEvent } from "../../features/analytics/analytics";
import LiveStream from "../video/LiveStream";
import HLSVideoPlayer from "../video/HLSVideoPlayer";

function EmbedPage({ match }) {
  const [content, setContent] = useState(null);
  const { content_id } = match.params;
  const poster = content?.featuredImage ? constants.imgUrl + content.featuredImage : null;

  useRecordContentWatchEvent(content_id);

  useEffect(() => {
    axios
      .get(`/api/content/embed/${content_id}`)
      .then(resp => {
        setContent(resp.data);
      })
      .catch(console.error);
  }, [content_id]);

  if (!content) return null;
  if (content.type === "video")
    return (
      <PlayerFE
        id={content.id}
        poster={poster}
        src={constants.cdnUrl + content.video}
        duration={content.duration}
      />
    );
  if (content.type === "live streaming" && content.isLiveStream)
    return (
      <LiveStream
        id={content.id}
        streamId={content.streamId}
        poster={poster}
        publishedDate={content.publishedDate}
      />
    );
  else if (content.type === "live streaming")
    return (
      <HLSVideoPlayer
        id={content.id}
        src={content.contentURI}
        poster={poster}
        duration={content.duration}
      />
    );

  return "This content type is not supported.";
}

export default EmbedPage;
